export enum Currency {
  EU = 'EU',
}
